
	/**
	 * 错误类型
	 */
	export const enum ErrorEnum {
		Non = -1,

		/**
		 * 成功
		 */
		Suc = 0,

		/**
		 * 密码错误
		 */
		PwdErr = 1,

		/**
		 * 没有找到用户
		 */
		NoFoundUser = 2,

		/**
		 * 没有登录
		 */
		NoLogin = 3,

		/**
		 * 没有找到 api
		 */
		NoAction = 4,

		/**
		 * 系统初始化错误
		 */
		SystemInit = 5,

		/**
		 * 数据验证出错
		 */
		DataValid = 6,

		/**
		 * 没有找到数据
		 */
		DataNoFound = 7,

		/**
		 * 数据错误
		 */
		DataError = 8
	}

	/**
	 * 申请授信状态
	 */
	export const enum CreditReqStateEnum {
		Non = 1,
		Accept = 2,
		Reject = 3
	}

	/**
	 * 支付渠道类型
	 */
	export const enum PaymentChannelTypeEnum {

		/**
		 * 银行转账
		 */
		Bank = 1,

		/**
		 * 扫码支付
		 */
		Qrcode = 2
	}

	/**
	 * 利润分配的状态
	 */
	export const enum ProfitStateEnum {

		/**
		 * 未分配
		 */
		Non = 1,

		/**
		 * 父经纪人已分配
		 */
		DistributeByParent = 2,

		/**
		 * 分配完成
		 */
		Complete = 3
	}

	/**
	 * 开户审核状态
	 */
	export const enum RegAuditStateEnum {
		Non = 1,
		Accept = 2,
		Reject = 3,
		Cancel = 4
	}

	/**
	 * 提醒类型
	 */
	export const enum RemindTypeEnum {
		Remind = 1000,
		TransferInRemind = 1001,
		TransferOutRemind = 1002,
		CreditReqRemind = 1003,
		RegRemindReject = 1004,
		RegRemindAccept = 1005,
		Audit = 2000,
		TransferInAudit = 2001,
		TransferOutAudit = 2002,
		CreditReqAudit = 2003,
		RegAudit = 2004
	}

	/**
	 * 手续费类型
	 */
	export const enum ServiceChargeTypeEnum {

		/**
		 * 固定
		 */
		Fixed = 0,

		/**
		 * 按比例
		 */
		Rate = 1
	}

	/**
	 * 订阅类型
	 */
	export const enum SignalrSubEnum {

		/**
		 * 提醒
		 */
		Remind = 100,

		/**
		 * 支付成功
		 */
		PaySuc = 101,

		/**
		 * 支付成功，但是入金失败
		 */
		PaySucButAccountError = 102
	}

	/**
	 * 入金状态枚举
	 */
	export const enum TransferInStateEnum {
		Non = 1,
		Accept = 2,
		Reject = 3,
		Paying = 4,
		PaySuc = 5,
		PayCancel = 6,
		PaySucButAccountError = 7
	}

	/**
	 * 出金状态枚举
	 */
	export const enum TransferOutStateEnum {
		Non = 1,
		Accept = 2,
		Reject = 3
	}

	/**
	 * 用户状态
	 */
	export const enum UserStateEnum {

		/**
		 * 可用
		 */
		Enable = 1,

		/**
		 * 禁用
		 */
		Disable = 2,

		/**
		 * 审核中
		 */
		Audit = 3,

		/**
		 * 审核拒绝
		 */
		AuditReject = 4,

		/**
		 * 审核未提交
		 */
		AuditNon = 5
	}

	/**
	 * 用户类型
	 */
	export const enum UserTypeEnum {

		/**
		 * 客户
		 */
		Customer = 1,

		/**
		 * 经纪人
		 */
		Broker = 2,

		/**
		 * 超管
		 */
		SuperAdmin = 3,

		/**
		 * 分账户管理员
		 */
		Admin = 4,

		/**
		 * crm中的审核管理员
		 */
		AuditAdmin = 5
	}
	export const enum PayChannelCategoryEnum {
		Platform = 1,
		Bank = 2
	}
	export const enum PayTypeEnum {
		Qr = 1,
		OpenUrl = 2,
		AliCall = 3,
		WeixinPublic = 4
	}



// WEBPACK FOOTER //
// ./src/types/crm-enums.ts